<template>
    <p class="link-wrapper">
        <a :href="linkLogin" target="_blank" class="link-wrapper__link">{{ ($t('loginLinkTitle')) }}</a>
    </p>
</template>

<script>
import { ref } from 'vue'
const linkLoginEnv = process.env.VUE_APP_LOGIN_LINK

export default {
  setup () {
    const linkLogin = ref(linkLoginEnv)

    return { linkLogin }
  }
}
</script>

<style lang="scss" scoped>
    .link-wrapper {
        margin-top: var(--spacing-m);

        @include respond-to('small') {
            margin-top: calc(var(--spacing-xl) + var(--spacing-s))
        }
        &__link {
            text-decoration: underline;
            color: var(--black950);
            position: relative;

            // Include the base font properties
            @include font-properties-base(var(--fontsize-xs), var(--fontweight-medium), normal);

            // Include the tablet font properties
            @include font-properties-tablet(var(--fontsize-s), var(--fontweight-medium), normal);

            &:after {
                content: '';
                position: absolute;
                width: 100%;
                height: 1px;
                background-color: var(--black950);
                top: 20px;
                left: 0;
            }
        }
    }
</style>
